<template>
  <div class="container">
    <div class="text-center">
      
    </div>
    <hello-world msg="Emil Österlund" />
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
